"use client";

import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import Tooltip from "@mui/material/Tooltip";
import { useSearchParams } from "next/navigation";

import { useUpdateQuery } from "@/hooks/use-update-query";

import { ValueFactorTab } from "../data/value-factor-tabs";

export const Select = ({ tabs }: { tabs: ValueFactorTab[] }) => {
  const searchParams = useSearchParams();
  const { updateQuery } = useUpdateQuery();
  const tabKey = searchParams.get("factor") ?? tabs[0].key;
  return (
    <div className="flex items-center gap-2.5 @2xl:hidden">
      <select
        id="tabs"
        name="tabs"
        className="block w-full rounded-md border-gray-300 focus:border-sky-600 focus:ring-sky-600"
        onChange={(e) => {
          const tabKey = tabs[e.target.selectedIndex].key;
          updateQuery({ name: "factor", value: tabKey });
        }}
        defaultValue={tabs.find((tab) => tab.key === tabKey)?.name}
      >
        {tabs.map((tab) => (
          <option key={tab.key}>{tab.name}</option>
        ))}
      </select>
      <Tooltip
        enterTouchDelay={0}
        arrow={true}
        placement="top"
        title={tabs.find((tab) => tab.key === tabKey)?.description}
        slotProps={{
          tooltip: { className: "bg-zinc-900 text-white" },
          arrow: { className: "text-zinc-900" },
        }}
      >
        <QuestionMarkCircleIcon className="h-6 w-6 text-zinc-400" />
      </Tooltip>
    </div>
  );
};
